export default "__VITE_ASSET__e1d817b5__"